
import { Union, Record } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { union_type, list_type, record_type, string_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { ofList } from "../fable_modules/fable-library-js.5.3.0/Map.js";
import { List_groupBy } from "../fable_modules/fable-library-js.5.3.0/Seq2.js";
import { comparePrimitives, stringHash } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { singleton, tryFind, map, empty as empty_1 } from "../fable_modules/fable-library-js.5.3.0/List.js";
import { join } from "../fable_modules/fable-library-js.5.3.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.3.0/Result.js";

export class FieldError extends Record {
    constructor(Field, Rule, Message) {
        super();
        this.Field = Field;
        this.Rule = Rule;
        this.Message = Message;
    }
}

export function FieldError_$reflection() {
    return record_type("ValidationErrors.FieldError", [], FieldError, () => [["Field", string_type], ["Rule", string_type], ["Message", string_type]]);
}

export class ValidationError extends Record {
    constructor(Errors) {
        super();
        this.Errors = Errors;
    }
}

export function ValidationError_$reflection() {
    return record_type("ValidationErrors.ValidationError", [], ValidationError, () => [["Errors", list_type(FieldError_$reflection())]]);
}

export function ofFieldErrors(errors) {
    return new ValidationError(errors);
}

export function toFieldMap(ve) {
    return ofList(List_groupBy((e) => e.Field, ve.Errors, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    });
}

export const empty = new ValidationError(empty_1());

export class ApiError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ValidationFailed", "OperationFailed", "NotFound"];
    }
}

export function ApiError_$reflection() {
    return union_type("ValidationErrors.ApiError", [], ApiError, () => [[["Item", ValidationError_$reflection()]], [["Item", string_type]], [["Item", string_type]]]);
}

/**
 * Extract a display-friendly string from any ApiError variant.
 * Use this as a drop-in replacement for plain string errors in non-form contexts.
 */
export function ApiErrorModule_message(_arg) {
    switch (_arg.tag) {
        case 2:
            return _arg.fields[0];
        case 0:
            return join("; ", map((e) => e.Message, _arg.fields[0].Errors));
        default:
            return _arg.fields[0];
    }
}

/**
 * Wrap a plain string error as OperationFailed.
 */
export function ApiErrorModule_ofString(msg) {
    return new ApiError(1, [msg]);
}

/**
 * True when the error is a ValidationFailed (per-field structured error).
 */
export function ApiErrorModule_isValidationError(_arg) {
    switch (_arg.tag) {
        case 1:
            return false;
        case 2:
            return false;
        default:
            return true;
    }
}

/**
 * True when the error is a NotFound (the requested resource does not exist).
 */
export function ApiErrorModule_isNotFound(_arg) {
    switch (_arg.tag) {
        case 0:
            return false;
        case 1:
            return false;
        default:
            return true;
    }
}

/**
 * Extract the first error message for a specific field, or None.
 * Returns None for OperationFailed and NotFound errors (they have no field association).
 */
export function ApiErrorModule_fieldError(field, _arg) {
    switch (_arg.tag) {
        case 1:
            return undefined;
        case 2:
            return undefined;
        default: {
            const input_1 = tryFind((e) => (e.Field === field), _arg.fields[0].Errors);
            if (input_1 == null) {
                return undefined;
            }
            else {
                return input_1.Message;
            }
        }
    }
}

/**
 * Bridge a smart constructor Result<'a, string> into Validation<'a, FieldError>
 * for use in applicative `validation { let! ... and! ... }` blocks.
 */
export function ValidationHelpers_forField(field, rule, result) {
    const input_1 = result;
    if (input_1.tag === 1) {
        return new FSharpResult$2(1, [singleton(new FieldError(field, rule, input_1.fields[0]))]);
    }
    else {
        return new FSharpResult$2(0, [input_1.fields[0]]);
    }
}

//# sourceMappingURL=ValidationErrors.js.map
